import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import domain from "../reusecomponent/domain";
import { SuccessToastContainer } from "../whatsapp/function/CustomFunction";
import { jwtDecode } from "jwt-decode";

export default function Documentation() {
  const [locations, setLocations] = useState([]);
  const [selectedGmb, setSelectedGmb] = useState("");

  const [minStar, setMinStar] = useState("");
  const [maxStar, setMaxStar] = useState("");
  const [sort, setSort] = useState("");
  const [limit, setLimit] = useState("");

  const [reviews, setReviews] = useState([]);
  const [url, setUrl] = useState("");
  const useridRef = useRef("");

  const token = useSelector((state) => state.Token.value);

  // Load GMB
  useEffect(() => {
    fetch(`${domain()}/gmb/gmb/list`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(json => {
        if (json.status) setLocations(json.data);
      });
      let data = jwtDecode(token);
      useridRef.current = data.id;
  }, []);

  // Generate + Fetch
  const generateData = async () => {
    if (!selectedGmb) return alert("Select business");

    let query = [];
    if (minStar) query.push(`min_star=${minStar}`);
    if (maxStar) query.push(`max_star=${maxStar}`);
    if (sort) query.push(`sort=${sort}`);
    if (limit) query.push(`limit=${limit}`);


    const apiUrl = `http://127.0.0.1:8000/api/gmb/get-review/${btoa(
      selectedGmb
    )}/${btoa(useridRef.current)}${query.length ? `?${query.join("&")}` : ""}`;

    setUrl(apiUrl);

    const res = await fetch(apiUrl);
    const json = await res.json();

    if (json.status) setReviews(json.data);
    else setReviews([]);
  };

  const copyUrl = () => {
    navigator.clipboard.writeText(url);
    SuccessToastContainer("URL Copied to Clipboard");
  };

  return (
    <div className="mt-3 px-3" style={{ width: "100%", fontSize: "14px" }}>
      <div className="card p-3 shadow-sm">

        {/* HEADER */}
        <h5 style={{ fontSize: "17px" }}>Google Reviews</h5>

        {/* SELECT */}
        <select
          className="form-select mb-3"
          onChange={(e) => setSelectedGmb(e.target.value)}
        >
          <option value="">Select Google My Business Account</option>
          {locations.map((loc) => (
            <option key={loc.id} value={loc.id}>
              {loc.label}
            </option>
          ))}
        </select>

        {/* FILTERS */}
        {selectedGmb && (
          <div className="row g-2 mb-2">
            <div className="col">
              <select className="form-select form-select-sm" onChange={(e)=>setMinStar(e.target.value)}>
                <option value="">Min Star</option>
                {[1,2,3,4,5].map(n => <option key={n} value={n}>{n}</option>)}
              </select>
            </div>

            <div className="col">
              <select className="form-select form-select-sm" onChange={(e)=>setMaxStar(e.target.value)}>
                <option value="">Max Star</option>
                {[1,2,3,4,5].map(n => <option key={n} value={n}>{n}</option>)}
              </select>
            </div>

            <div className="col">
              <select className="form-select form-select-sm" onChange={(e)=>setSort(e.target.value)}>
                <option value="">Sort</option>
                <option value="latest">Latest</option>
                <option value="oldest">Oldest</option>
              </select>
            </div>

            <div className="col">
              <input
                type="number"
                placeholder="Limit"
                className="form-control form-control-sm"
                onChange={(e)=>setLimit(e.target.value)}
              />
            </div>
          </div>
        )}

        {/* BUTTON */}
        {selectedGmb && (
          <button className="btn btn-success w-100 mb-3" onClick={generateData}>
            Generate URL & Show Widget
          </button>
        )}

        {/* ✅ URL + COPY BUTTON */}
        {url && (
          <div className="d-flex align-items-center mb-3" style={{ gap: "10px" }}>
            <input
              type="text"
              value={url}
              readOnly
              className="form-control"
              style={{ fontSize: "13px", background: "#f8f9fa" }}
            />

            <button
              className="btn btn-primary btn-sm"
              onClick={copyUrl}
              style={{ whiteSpace: "nowrap" }}
            >
              Copy
            </button>
          </div>
        )}

        {/* WIDGET */}
        {reviews.length > 0 && (
          <div className="slider-wrapper">
            <div className="slider-track">
              {reviews.map((r) => (
                <div className="review-card" key={r.id}>

                  <div className="review-header">
                    <img src={r.profile_picture} alt="" />
                    <div>
                      <div className="name">{r.reviewer_name}</div>
                      <div className="date">
                        {new Date(r.created_at).toLocaleDateString()}
                      </div>
                    </div>
                  </div>

                  <div className="stars">
                    {"⭐".repeat(r.rating_number || 0)}
                  </div>

                  <div className="message">
                    {r.message || "No comment"}
                  </div>

                </div>
              ))}
            </div>
          </div>
        )}

      </div>

      {/* CSS */}
      <style>{`
        .slider-wrapper {
          overflow: hidden;
          width: 100%;
        }

        .slider-track {
          display: flex;
          gap: 15px;
          animation: scroll 35s linear infinite;
        }

        .review-card {
          min-width: 280px;
          background: #fff;
          border-radius: 10px;
          padding: 12px;
          border: 1px solid #eee;
        }

        .review-header {
          display: flex;
          gap: 10px;
          align-items: center;
        }

        .review-header img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        .name {
          font-weight: 600;
        }

        .date {
          font-size: 12px;
          color: #777;
        }

        .stars {
          color: #f4b400;
          margin-top: 5px;
        }

        .message {
          margin-top: 8px;
        }

        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}